// extracted by mini-css-extract-plugin
module.exports = {"appdefsManage":"style__appdefsManage__weZRP","verticalNav":"style__verticalNav__KcZ5l"};